import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { ImportInstructionDto, ModificationDto} from "app/ApiClient";

export interface ImportInstructionState {
  loading: LoadingState;
  importLoading: LoadingState;
  data: ImportInstructionDto;
  resultModification: Nullable<ModificationDto>;
  errorMessage?: string;
}
export const initialImportInstructionState: ImportInstructionState = {
  data: {},
  loading: LoadingState.idle,
  resultModification: null,
  importLoading: LoadingState.idle,
};
